// -------------------------------------------------------------
// ENTERPRISE AUDIT LOG MANAGER FOR SATALA DERMATECH ESSENTIAL
// Handles security logging with Severity: INFO, WARNING, CRITICAL
// -------------------------------------------------------------

const AUDIT_STORAGE_KEY = 'satala_audit_logs';

export const INITIAL_AUDIT_LOGS = [];

export const getAuditLogs = () => {
  try {
    const saved = localStorage.getItem(AUDIT_STORAGE_KEY);
    if (saved) {
      const parsed = JSON.parse(saved);
      if (Array.isArray(parsed) && parsed.length > 0) return parsed;
    }
  } catch (e) {
    console.error('Error loading audit logs:', e);
  }
  return INITIAL_AUDIT_LOGS;
};

export const logAuditEvent = ({
  actor = 'System / User',
  role = 'System',
  action = 'System Event',
  target = '-',
  ip = '127.0.0.1 (Localhost)',
  browser = 'Chrome',
  device = 'Desktop PC',
  country = 'Indonesia',
  result = 'Sukses',
  severity = 'INFO', // 'INFO' | 'WARNING' | 'CRITICAL'
  details = ''
}) => {
  try {
    const logs = getAuditLogs();
    const newLog = {
      id: `log_${Date.now()}_${Math.floor(1000 + Math.random() * 8999)}`,
      timestamp: new Date().toISOString(),
      actor,
      role,
      action,
      target,
      ip,
      browser,
      device,
      country,
      result,
      severity,
      details
    };

    const updated = [newLog, ...logs].slice(0, 500); // Keep latest 500 logs
    localStorage.setItem(AUDIT_STORAGE_KEY, JSON.stringify(updated));
    window.dispatchEvent(new CustomEvent('satala_audit_log_added', { detail: newLog }));
    return newLog;
  } catch (e) {
    console.error('Error logging audit event:', e);
    return null;
  }
};

export const clearAuditLogs = () => {
  try {
    localStorage.removeItem(AUDIT_STORAGE_KEY);
    window.dispatchEvent(new Event('satala_audit_logs_changed'));
  } catch (e) {}
};
